import './js/username-request';
import './js/verify-phone';
// import './js/change-password';
// import './js/reset-password';

import Registration from './js/registration';
import ChangePassword from './js/change-password';
import ShowPassword from './js/show-password';
import ResetPassword from './js/reset-password';

new Registration().initialize();
new ChangePassword().initialize();
new ShowPassword().initialize();
new ResetPassword().initialize();
